/* eslint-disable react/jsx-handler-names */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable relay/must-colocate-fragment-spreads */
import type { StyleProp } from '@vtex/admin-ui'
import { Modal, ModalContent, useModalState, Text, csx } from '@vtex/admin-ui'
import React from 'react'
import { useIntl } from 'react-intl'
import { readInlineData } from 'relay-runtime'
import { graphql } from 'babel-plugin-relay/macro'
import { useFragment } from 'react-relay-offline'
import { useHistory } from 'react-router'

import type {
  SalesAssociatesModal_salesAssociate$data,
  SalesAssociatesModal_salesAssociate$key,
} from './__generated__/SalesAssociatesModal_salesAssociate.graphql'
import { Avatar } from '../Avatar/Avatar'
import { useSalesAssociates } from '../../hooks/useSalesAssociates'
import type { SalesAssociatesModal_salesAssociatesConnection$key } from './__generated__/SalesAssociatesModal_salesAssociatesConnection.graphql'
import { OpenGoalsButton } from '../Goals'

const itemStyles: StyleProp = {
  alignItems: 'center',
  paddingX: '$space-7',
  paddingY: '$space-3',
  cursor: 'pointer',
  userSelect: 'none',
  display: 'flex',
}

export type SalesAssociatesModalProps = {
  onSalesAssociateSelect: (
    salesAssociate: SalesAssociatesModal_salesAssociate$data | null | undefined
  ) => void
}

export const SalesAssociatesModal = (props: SalesAssociatesModalProps) => {
  const intl = useIntl()
  const publishModal = useModalState()
  const { salesAssociates } = useSalesAssociates()

  const handleModalClose = () => {
    publishModal.hide()
  }

  const history = useHistory()

  const handleItemClick = (
    clickedItem: SalesAssociatesModal_salesAssociate$key | null
  ) => () => {
    const item = readInlineData(
      graphql`
        fragment SalesAssociatesModal_salesAssociate on SalesAssociate @inline {
          id
          ...SalesAssociatePasswordModal_salesAssociate
        }
      `,
      clickedItem
    )

    props.onSalesAssociateSelect(item)
    history.push('#/sales-associate-password')
  }

  const salesAssociatesData = useFragment<SalesAssociatesModal_salesAssociatesConnection$key>(
    graphql`
      fragment SalesAssociatesModal_salesAssociatesConnection on SalesAssociateConnection {
        edges {
          node {
            id
            name
            avatar {
              url
            }
            ...SalesAssociatesModal_salesAssociate
          }
        }
      }
    `,
    salesAssociates
  )

  return (
    <>
      <OpenGoalsButton onClick={publishModal.toggle} />
      <Modal
        onClick={handleModalClose}
        state={publishModal}
        aria-label={intl.formatMessage({ id: 'salesAssociatesModalAriaLabel' })}
      >
        <div
          className={csx({
            border: '$neutral',
            paddingX: '$space-7',
            paddingY: '$space-4',
          })}
        >
          <p>{intl.messages.salesAssociateHeader} </p>
        </div>
        <ModalContent className={csx({ paddingX: '$space-0' })}>
          {salesAssociatesData.edges?.map((salesAssociateItem) => (
            <div
              key={salesAssociateItem?.node?.id}
              onClick={handleItemClick(salesAssociateItem.node)}
              data-testid="goals-modal-item"
              className={csx({ ...itemStyles })}
            >
              <Avatar src={salesAssociateItem.node.avatar?.url} size={2} />
              <Text variant="title2" className={csx({ paddingX: '$space-4' })}>
                {salesAssociateItem?.node?.name}
              </Text>
            </div>
          ))}
        </ModalContent>
      </Modal>
    </>
  )
}
